export default function setHomeCtaMarquee() {
  const sections = document.querySelectorAll('[data-home-marquee]');

  sections.forEach((section) => {
    const container = section.querySelector('.home-marquee-viewport');
    if (!container) {
      return;
    }

    const items = Array.from(section.querySelectorAll('.home-marquee-item'));
    if (!items.length) {
      return;
    }

    const updateOpacity = () => {
      const containerRect = container.getBoundingClientRect();
      const centerY = containerRect.top + containerRect.height / 2;
      const maxDistance = containerRect.height / 2;

      items.forEach((item) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenterY = itemRect.top + itemRect.height / 2;
        const distance = Math.abs(centerY - itemCenterY);
        const normalizedDistance = Math.min(distance / maxDistance, 1);
        const opacity = 1 - normalizedDistance * 0.75;
        item.style.opacity = opacity.toString();
      });
    };

    const animationFrame = () => {
      updateOpacity();
      window.requestAnimationFrame(animationFrame);
    };

    window.requestAnimationFrame(animationFrame);
  });
}
